const API_ROOT_SERVICE = 'Payments';

export const PAYMENTS_SERVICE = {
    getConfig
};

// Plain fetch (not API_HELPER.apiCall): a failing config call must never redirect to the error page,
// the caller just keeps the default payment options.
function getConfig() {
    const url = [process.env.VUE_APP_API_ROOT.replace(/\/+$/, ''), API_ROOT_SERVICE, 'config'].join('/');

    return fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(response => {
            if (!response.ok) {
                return Promise.reject(new Error(`Payments config returned ${response.status}`));
            }
            return response.json();
        });
}
